import { render, staticRenderFns } from "./OtherWebsite.vue?vue&type=template&id=6aac61e4&scoped=true"
import script from "./OtherWebsite.vue?vue&type=script&lang=js"
export * from "./OtherWebsite.vue?vue&type=script&lang=js"
import style0 from "./OtherWebsite.vue?vue&type=style&index=0&id=6aac61e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac61e4",
  null
  
)

export default component.exports